import * as sharedStyles from 'common/builder/components/chart/FlowChart/nodes/shared/styles'
import { toPx } from 'common/builder/components/chart/utils/toPx'

export const nextStepWrapper: React.CSSProperties = {
  display: 'flex',
  width: toPx(sharedStyles.NEXT_STEP_DOT_SIZE),
  paddingLeft: toPx(sharedStyles.NEXT_STEP_DOT_SIZE / 2),
  marginLeft: toPx(sharedStyles.Spacings.SMALL),
  flexShrink: 0,
}
